import { EnvAuth } from '@sc/data-access-models';

export interface AuthOktaConfig {
  guardRedirectUrl: string;
  envAuth: EnvAuth;
}
